import React, { useMemo, ReactNode, useRef } from "react";
import clsx from "clsx";
import { _LandingInnovationProductList } from "../LandingInnovation.styled";
import FlexBox from "../../../FlexBox/FlexBox";
import { _LandingInnovationRoot } from "../LandingInnovation.styled";
import InnovationProductUmami, {
  IInnovationProductUmamiProps,
} from "./InnovationProductUmami/InnovationProductUmami";
import {
  _LandingInnovationUmamiProductList,
  _LandingInnovationUmamiRoot,
  InnovationProductItem,
  InnovationProductListWrapper,
} from "./LandingInnovationUmami.styled";
import ButtonContext from "../../../../Foundation/Button/Button.context";
import TouchScroll from "../../../TouchScroll/TouchScroll";
import getMobileOperatingSystem from "../../../../Utils/getMobileOperatingSystem";
export type ILandingInnovationProductUmami<T extends any = any> = {
  id_product: string;
  videoSlug: string;
  poster?: string;
  title: string;
  tag?: string;
  description?: ReactNode;
  price?: string;
  priceSubtitle?: string;
  ctaLabel?: string;
} & T & {};

interface ILandingInnovationUmamiProps<T extends any = any> {
  products?: ILandingInnovationProductUmami<T>[];
  onClickProduct?: (product: ILandingInnovationProductUmami<T>) => void;
  showLessLabel: string;
  showMoreLabel: string;
  renderProduct?: (
    data: IInnovationProductUmamiProps<T>,
    index: number
  ) => ReactNode;
}
const LandingInnovationUmami = <T extends any = any>(
  props: ILandingInnovationUmamiProps<T>
) => {
  const {
    products,
    onClickProduct,
    showLessLabel,
    showMoreLabel,
    renderProduct,
  } = props;
  const sectionRef = useRef<HTMLDivElement | null>(null);
  const os = getMobileOperatingSystem();

  const productList = useMemo(() => {
    return products?.slice(0, 6) || [];
  }, [products]);

  const itemRenderer = (
    product: ILandingInnovationProductUmami<T>,
    index: number
  ) => {
    const _data: IInnovationProductUmamiProps = {
      className: "innovation-umami-product-item",
      product: product,
      onClick: onClickProduct,
      showLessLabel: showLessLabel,
      showMoreLabel: showMoreLabel,
    };
    return (
      <React.Fragment key={product.id_product}>
        {renderProduct ? (
          renderProduct(_data, index)
        ) : (
          <InnovationProductUmami key={product.id_product} {..._data} />
        )}
      </React.Fragment>
    );
  };

  return (
    <ButtonContext.Provider
      value={{ backgroundColor: "#072F41", textColor: "white" }}
    >
      <_LandingInnovationUmamiRoot
        className="landing-innovations-umami"
        ref={sectionRef}
      >
        <div className={clsx("landing-innovations-umami__container")}>
          <_LandingInnovationUmamiProductList
            $isList={true}
            $itemFullWidth={true}
            $os={os}
          >
            <FlexBox
              justify="center"
              style={{
                maxWidth: 1348,
                width: "100%",
                margin: "0 auto",
              }}
            >
              <InnovationProductListWrapper>
                {productList?.map((product, index) => {
                  const isLastItem = index === productList.length - 1;
                  return (
                    <TouchScroll
                      key={product.id_product}
                      upwardOffset={isLastItem ? 0 : 0}
                      downwardOffset={0}
                    >
                      {({ containerRef }) => (
                        <InnovationProductItem
                          key={product.id_product}
                          ref={containerRef}
                          $os={os}
                        >
                          {itemRenderer(product, index)}
                        </InnovationProductItem>
                      )}
                    </TouchScroll>
                  );
                })}
              </InnovationProductListWrapper>
            </FlexBox>
          </_LandingInnovationUmamiProductList>
        </div>
      </_LandingInnovationUmamiRoot>
    </ButtonContext.Provider>
  );
};

export default LandingInnovationUmami;
